import React from 'react';
import { EverestRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

const repository = new EverestRepository();

class EverestMePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null
    };
  }

  componentDidMount() {
    repository.findMe(null, (data) => this.setState({ user: data }));
  }

  render() {
    const { user, loaded } = this.state;
    return (
      <>
        <NavigationBar user={user} location={this.props.location} />
        {loaded && <>
          MyAccount!!!
        </>}
      </>
    );
  }
}

export { EverestMePage };
